import React, { useState, useEffect } from "react";
import { aesEncrypt, getPicture, reqCheck } from "./services";
import defaultImg from "./images/default.jpg";
import { CSSTransition } from "react-transition-group";

import "./index.scss";

export interface VerifySlideFixedFC {
  title?: string;
  isSlideShow?: boolean;
  onCancel: () => void;
  onSuccess: (code?: string) => void;
  setSize?: {
    imgHeight: string;
    imgWidth: string;
  };
  barSize?: {
    width: string;
    height: string;
  };
  vSpace?: number;
}

const VerifySlideFixed: React.FC<VerifySlideFixedFC> = (props) => {
  const {
    isSlideShow = false,
    setSize = {
      imgHeight: "155",
      imgWidth: "310",
    },
    barSize = { width: "310px", height: "40px" },
    vSpace = 25,
    title = "",
    onCancel,
    onSuccess,
  } = props;

  const [visible, setVisible] = useState(isSlideShow);
  const [backImgBase, setbackImgBase] = useState("");
  const [blockBackImgBase, setBlockBackImgBase] = useState("");
  const [passFlag, setPassFlag] = useState<string | boolean>("");
  const [text, setText] = useState("向右滑动完成验证");
  const [leftBarWidth, setLeftBarWidth] = useState("");
  const [leftBarBorderColor, setLeftBarBorderColor] = useState("");
  const [startLeft, setStartLeft] = useState<any>("");
  const [barAreaLeft, setBarAreaLeft] = useState(0);
  const [isEnd, setIsEnd] = useState(false);
  const [startMoveTime, setStartMoveTime] = useState<any>("");
  const [iconColor, setIconColor] = useState("");
  const [status, setStatus] = useState(false);
  const [moveBlockBackgroundColor, setMoveBlockBackgroundColor] =
    useState("rgb(255, 255, 255)");
  const [moveBlockLeft, setMoveBlockLeft] = useState("");
  const [barAreaOffsetWidth, setBarAreaOffsetWidth] = useState(0);
  const [blockSize, setBlockSize] = useState({
    width: "40px",
    height: "40px",
  });
  const [secretKey, setsecretKey] = useState(""); // 后端返回的加密字钥
  const [tipWords, setTipWords] = useState("");
  let timer: boolean = true;
  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    setVisible(isSlideShow);
  }, [isSlideShow]);

  const getData = () => {
    getPicture().then((res: any) => {
      console.log(res, "res");
      const { repCode, repData } = res || res.data;

      if (repCode === 1) {
        console.log("123123");
        setbackImgBase(repData.jigsawImageBase64);
        setBlockBackImgBase(repData.originalImageBase64);
        setsecretKey(repData.key);
      } else {
        setPassFlag(false);
      }
    });
  };

  const setBarArea = (event: any) => {
    let barAreaLeft = event && event.getBoundingClientRect().left;
    let barAreaOffsetWidth = event && event.offsetWidth;
    setBarAreaLeft(barAreaLeft);
    setBarAreaOffsetWidth(barAreaOffsetWidth);
  };

  const start = (e: any) => {
    e = e || window.event;
    if (!e.touches) {
      //兼容PC端
      var x = e.clientX;
    } else {
      //兼容移动端
      var x = e.touches[0].pageX;
    }
    setStartLeft(Math.floor(x - barAreaLeft));
    setStartMoveTime(+new Date()); //开始滑动的时间
    if (isEnd === false) {
      setText("");
      setMoveBlockBackgroundColor("#337ab7");
      setLeftBarBorderColor("#337AB7");
      setIconColor("#fff");
      setStatus(true);
      //   this.text = "";
      e.stopPropagation();
    }
  };

  const move = (e: any) => {
    if (!timer) return;
    timer = false;
    e = e || window.event;
    let x;
    if (status && isEnd === false) {
      if (!e.touches) {
        // 兼容PC端
        x = e.clientX;
      } else {
        //兼容移动端
        x = e.touches[0].pageX;
      }

      let bar_area_left = barAreaLeft;
      let move_block_left = x - bar_area_left; //小方块相对于父元素的left值
      if (
        move_block_left  >=
        barAreaOffsetWidth - parseInt(blockSize.width) + startLeft
      ) {
        move_block_left =
        barAreaOffsetWidth - parseInt(blockSize.width) + startLeft
      }
      if (move_block_left <= startLeft) {
        move_block_left = startLeft;
      }
      //拖动后小方块的left值
      setMoveBlockLeft(move_block_left - startLeft + "px");
      setLeftBarWidth(move_block_left - startLeft + "px");
    }
    setTimeout(() => {
      timer = true;
    }, 10);
  };

  const end = () => {
    const endMovetime = +new Date();
    console.log("moveBlockLeft", moveBlockLeft);

    //判断是否重合
    if (status && isEnd === false) {
      var moveLeftDistance = parseInt((moveBlockLeft || "").replace("px", ""));
      let data = {
        key: secretKey,
        point: secretKey
          ? aesEncrypt(JSON.stringify({ x: moveLeftDistance, y: 0 }), secretKey)
          : JSON.stringify({ x: moveLeftDistance, y: 0 }),
        ts: Date.now(),
      };
      reqCheck(data).then((res: any) => {
        const { repCode, repMsg, repData } = res || res.data;

        if (repCode === 1) {
          setIsEnd(true);
          setPassFlag(true);
          setTipWords(
            `${((endMovetime - startMoveTime) / 1000).toFixed(2)}s验证成功`
          );
          setTimeout(() => {
            setTipWords("");
            onSuccess(repData);
            closeBox();
          }, 1000);
        } else {
          setIsEnd(true);
          setMoveBlockBackgroundColor("#d9534f");
          setLeftBarBorderColor("#d9534f");
          setIconColor("#fff");
          setPassFlag(false);
          setTipWords(repMsg || "验证失败");
        }
        setTimeout(() => {
          refresh();
          setTipWords("");
        }, 1000);
      });
      setStatus(false);
    }
  };

  const refresh = () => {
    getData();
    setMoveBlockLeft("");
    setLeftBarWidth("");
    setText("向右滑动完成验证");
    setMoveBlockBackgroundColor("#fff");
    setLeftBarBorderColor("#337AB7");
    setIconColor("#fff");
    setStatus(false);
    setIsEnd(false);
  };

  const closeBox = () => {
    setVisible(false);
    onCancel();
  };

  return (
    <div
      className="mask"
      style={{ display: visible ? "block" : "none" }}
      onTouchEnd={() => {
        end();
      }}
      onTouchMove={(e) => {
        status && move(e);
      }}
      onMouseMove={(e) => {
        status && move(e);
      }}
      onMouseUp={() => {
        end();
      }}
    >
      <div className="verifybox" style={{ maxWidth: 340 }}>
        <div className="verifybox-top">
          {title || ""}
          <span className="verifybox-close" onClick={() => closeBox()}>
            <i className="iconfont icon-close"></i>
          </span>
        </div>
        <div className="verifybox-bottom" style={{ padding: "15px" }}>
          <div style={{ position: "relative" }} className="stop-user-select">
            <div className="verify-img-out" style={{ height: 180 }}>
              <div
                className="verify-img-panel"
                style={{ width: 310, height: 155 }}
              >
                {true ? (
                  <img
                    src={"data:image/png;base64," + backImgBase}
                    alt=""
                    style={{ width: "100%", height: "100%", display: "block" }}
                    draggable="false"
                  />
                ) : (
                  <img
                    src={defaultImg}
                    alt=""
                    style={{ width: "100%", height: "100%", display: "block" }}
                    draggable="false"
                  />
                )}
                <div className="verify-refresh" onClick={() => refresh()}>
                  <i className="iconfont icon-refresh"></i>
                </div>
                <CSSTransition
                  in={2 > 0}
                  timeout={150}
                  classNames="tips"
                  unmountOnExit
                >
                  <span
                    className={
                      passFlag
                        ? `${"verify-tips"} ${"suc-bg"}`
                        : `${"verify-tips"} ${"err-bg"}`
                    }
                  >
                    {tipWords}
                  </span>
                </CSSTransition>
              </div>
            </div>
          </div>
          <div
            className="verify-bar-area"
            style={{
              height: barSize.height,
              lineHeight: barSize.height,
            }}
            ref={(bararea) => {
              setBarArea(bararea);
            }}
          >
            <span className="verify-msg">{text}</span>
            <div
              className="verify-left-bar"
              style={{
                width:
                  leftBarWidth !== undefined ? leftBarWidth : barSize.height,
                height: barSize.height,
                borderColor: leftBarBorderColor,
                transition: undefined,
              }}
            >
              <span className="verify-msg">{""}</span>
              <div
                className="verify-move-block"
                onTouchStart={(e) => {
                  start(e);
                }}
                onMouseDown={(e) => {
                  start(e);
                }}
                style={{
                  width: barSize.height,
                  height: barSize.height,
                  backgroundColor: moveBlockBackgroundColor,
                  left: moveBlockLeft,
                  transition: undefined,
                }}
              >
                <div
                  className="verify-sub-block"
                  style={{
                    width:
                      Math.floor((parseInt(setSize.imgWidth) * 47) / 310) +
                      "px",
                    height: setSize.imgHeight,
                    top: "-" + (parseInt(setSize.imgHeight) + vSpace) + "px",
                    backgroundSize: setSize.imgWidth + " " + setSize.imgHeight,
                  }}
                  onTouchStart={(e) => {
                    e.stopPropagation();
                  }}
                  onMouseDown={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <img
                    src={"data:image/png;base64," + blockBackImgBase}
                    alt=""
                    style={{ width: "100%", height: "100%", display: "block" }}
                    draggable="false"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifySlideFixed;
